import { render, staticRenderFns } from "./ClinicalNotesContainer.vue?vue&type=template&id=c527b248&"
import script from "./ClinicalNotesContainer.vue?vue&type=script&lang=js&"
export * from "./ClinicalNotesContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports